import React from 'react';
import { useTranslations } from '../../locales/useTranslations';
import FadeInAnimation from '../Common/FadeInAnimation';
import { BiCheckCircle } from 'react-icons/bi';

const WooCommerceSchnittstellePricing = () => {
    const { t } = useTranslations();

    const features = [
        t('woocommerceSchnittstelle_pricing_feature1'),
        t('woocommerceSchnittstelle_pricing_feature2'),
        t('woocommerceSchnittstelle_pricing_feature3'),
        t('woocommerceSchnittstelle_pricing_feature4'),
        t('woocommerceSchnittstelle_pricing_feature5'),
        t('woocommerceSchnittstelle_pricing_feature6'),
        t('woocommerceSchnittstelle_pricing_feature7'),
        t('woocommerceSchnittstelle_pricing_feature8')
    ];

    return (
        <section id="pricing" className="wc-pricing pt-100 pb-100">
            <div className="wc-pricing__decoration"></div>

            <div className="container wc-pricing__content">
                <div className="row mb-5">
                    <div className="col-12 text-center">
                        <FadeInAnimation direction="up" delay={50}>
                            <span className="wc-section-badge">
                                {t('woocommerceSchnittstelle_pricing_badge')}
                            </span>
                            <h2 className="wc-section-title">
                                {t('woocommerceSchnittstelle_pricing_title')}
                            </h2>
                            <p className="wc-section-subtitle">
                                {t('woocommerceSchnittstelle_pricing_subtitle')}
                            </p>
                        </FadeInAnimation>
                    </div>
                </div>

                <div className="row justify-content-center">
                    <div className="col-lg-6 col-md-8">
                        <FadeInAnimation direction="up" delay={100}>
                            <div className="wc-pricing__card">
                                <div className="wc-pricing__popular">
                                    {t('woocommerceSchnittstelle_pricing_popular')}
                                </div>

                                <div className="wc-pricing__price-box">
                                    <div className="wc-pricing__price">89,99€</div>
                                    <div className="wc-pricing__period">
                                        {t('woocommerceSchnittstelle_pricing_period')}
                                    </div>
                                    <p className="wc-pricing__price-desc">
                                        {t('woocommerceSchnittstelle_pricing_description')}
                                    </p>
                                </div>

                                <div className="wc-pricing__features">
                                    {features.map((feature, index) => (
                                        <div key={index} className="wc-pricing__feature-item">
                                            <BiCheckCircle />
                                            <span>{feature}</span>
                                        </div>
                                    ))}
                                </div>

                                <a href="/kontakt" className="wc-pricing__cta">
                                    {t('woocommerceSchnittstelle_pricing_cta')}
                                </a>
                            </div>
                        </FadeInAnimation>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default WooCommerceSchnittstellePricing;
